import React, { useState, useEffect, useContext } from 'react';
import { getDirection, pexios } from '../../utils/functions';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Moment from 'moment-jalaali';
import ReportImages from '../../components/pages/report/ReportImages';
import ReportClientInfo from "../../components/pages/report/ReportClientInfo";
import ReportExpert from "../../components/pages/report/ReportExpert";
import ReportDescription from "../../components/pages/report/ReportDescription";
import ReportButtons from "../../components/pages/report/ReportButtons";
import Modal from '../../components/master/Modal';
import { useTranslation } from 'react-i18next';
import { TitleContext } from '../../App';

export default function ReportSingle() {
    const params = useParams();
    const selector = useSelector(store => store.routerData);
    const { t, i18n } = useTranslation();

    const id = params?.id || selector?.id;

    const [report, setReport] = useState({
        accident: {
            description: [],
            attachments: [],
        },
        attachments: [],
        culprit: {
            user: {},
            third: {},
            body: {},
        },
        losses: {
            user: {},
            third: {},
        },
        ///
        archives: [],
        complements: []
    });

    const { accident } = report;
    const [loader,setLoader] = useState(false);
    // const {setTitle} = useContext(TitleContext);
    // useEffect(()=>{
    //   setTitle('')
    // },[])

    useEffect(() => {
        setLoader(true)
        pexios('api/v2/get_report_by_id', 'post', { id })
            .then(res => {
                const report = res.data.data;
                setReport(report);
                setLoader(false)
            })
    }, [id]);

    return (
      <div className="content">
        {loader ? (
          <Modal visible={loader}>
            <div className="loader-modal">
              <i className="fas fa-spinner fa-spin" />
            </div>
          </Modal>
        ) : (
          <div className="report" data-dir={getDirection(i18n.language)}>
            <p className="title">{t('File Details')}</p>
            <div className="box b-bl-sharp">
              <div className="textParent">
                <div className="text">{t('File Num')}:</div>
                <div className="text text-left">{accident.id}</div>
              </div>
              <div className="textParent">
                <div className="text">{t('Date and Time of accident')}:</div>
                <div className="text text-left">
                  {Moment(accident.created_at).format("jYYYY/jM/jD HH:mm")}
                </div>
              </div>
              <div className="textParent">
                <div className="text">{t('File type')}:</div>
                <div className="text text-left">
                  {accident.insurance_type === "third" ? t('Third') : t('Body')}
                </div>
              </div>
            </div>
            <ReportImages report={report} />
            <ReportClientInfo report={report} />
            <ReportExpert report={report} />
            <ReportDescription report={report} />
            <ReportButtons report={report} />
          </div>
        )}
      </div>
    );

}
